function parseWaypointsString(waypoints, pathLength, distance) {
  if (waypoints) {
    return waypoints.split(',').map(pt => Number(pt));
  }
  // Old style, no specific waypoints, create them, on average one per km
  let nPoints = Math.ceil(3 + Math.sqrt(distance));
  // No more than nr of points in path
  if (nPoints > pathLength) {
    nPoints = pathLength;
  }
  return Array(nPoints)
    .fill()
    .map((item, idx) => Math.round(((idx + 1) * pathLength) / nPoints) - 1);
}

export default parseWaypointsString;
